import { cn } from '@/lib/classNames';

export function Spinner({ className, small }: { className?: string; small?: boolean }) {
  return (
    <div
      className={cn('spinner-border text-ast', small && 'spinner-border-sm', className)}
      role="status"
      aria-label="Loading"
    >
      <span className="visually-hidden">Loading…</span>
    </div>
  );
}
